import React from "react";
import OriginalAdvancedSelect, { AdvancedSelectControlProps } from "@edaz/edazkit/controls/AdvancedSelect";
import { setVisitedProperty } from "../utils/validationPatch";
import { IBindingProps } from "@frui.ts/views";
import { PropertyName } from "@frui.ts/helpers";
import { CommonInputProps } from "@frui.ts/bootstrap/dist/controls/commonInputProps";

export default function AdvancedSelect<TTarget, IsMulti extends boolean = false>(
  props: Omit<AdvancedSelectControlProps<IsMulti>, "onChange" | "value"> & IBindingProps<TTarget> & CommonInputProps
) {
  const { onBlur, ...rest } = props;
  const { target, property } = props as { target: TTarget; property: PropertyName<TTarget> };
  const modifiedOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(e);
    }

    setVisitedProperty(target, property);
  };

  return <OriginalAdvancedSelect onBlur={modifiedOnBlur} {...rest} />;
}
